import { MapPortalGroup } from "../IronmonMapUtils";

export const kantoPortalGroups: MapPortalGroup[] = [
  {
    color: "#03ecfc",
    area: "S. S. Aqua",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7633,
          y: 4346,
        },
        portal2: {
          x: 7404,
          y: 4707,
        },
      },

      // Top level rooms
      {
        portal1: {
          x: 7595,
          y: 4546,
        },
        portal2: {
          x: 7851,
          y: 4884,
        },
      },
      {
        portal1: {
          x: 7595,
          y: 4644,
        },
        portal2: {
          x: 7851,
          y: 4956,
        },
      },
      {
        portal1: {
          x: 7501,
          y: 4547,
        },
        portal2: {
          x: 7626,
          y: 4885,
        },
      },
      {
        portal1: {
          x: 7498,
          y: 4644,
        },
        portal2: {
          x: 7626,
          y: 4956,
        },
      },
      {
        portal1: {
          x: 7324,
          y: 4547,
        },
        portal2: {
          x: 7387,
          y: 4883,
        },
      },
      {
        portal1: {
          x: 7324,
          y: 4645,
        },
        portal2: {
          x: 7387,
          y: 4956,
        },
      },
      {
        portal1: {
          x: 7229,
          y: 4548,
        },
        portal2: {
          x: 7161,
          y: 4884,
        },
      },
      {
        portal1: {
          x: 7229,
          y: 4645,
        },
        portal2: {
          x: 7161,
          y: 4955,
        },
      },

      // Stairs
      {
        portal1: {
          x: 7381,
          y: 4492,
        },
        portal2: {
          x: 7356,
          y: 5157,
        },
      },

      // Ladder
      {
        portal1: {
          x: 7624,
          y: 5222,
        },
        portal2: {
          x: 7690,
          y: 4564,
        },
      },
    ],
  },
  {
    color: "#4a4142",
    area: "Diglett Cave",
    portals: [
      // Entrance
      {
        portal1: {
          x: 8387,
          y: 3756,
        },
        portal2: {
          x: 6973,
          y: 4123,
        },
      },

      // Exit
      {
        portal1: {
          x: 6589,
          y: 3533,
        },
        portal2: {
          x: 3415,
          y: 1676,
        },
      },
    ],
  },
  {
    color: "#704308",
    area: "Rock Tunnel",
    portals: [
      // Entrance
      {
        portal1: {
          x: 9296,
          y: 2278,
        },
        portal2: {
          x: 8775,
          y: 2111,
        },
      },

      // Ladders
      {
        portal1: {
          x: 9001,
          y: 1879,
        },
        portal2: {
          x: 9001,
          y: 2375,
        },
      },
      {
        portal1: {
          x: 8538,
          y: 2572,
        },
        portal2: {
          x: 8538,
          y: 2089,
        },
      },
      {
        portal1: {
          x: 8569,
          y: 1892,
        },
        portal2: {
          x: 8571,
          y: 2388,
        },
      },
      {
        portal1: {
          x: 8538,
          y: 2239,
        },
        portal2: {
          x: 8538,
          y: 1758,
        },
      },

      // Exit
      {
        portal1: {
          x: 9144,
          y: 1784,
        },
        portal2: {
          x: 9389,
          y: 1695,
        },
      },
    ],
  },
  {
    color: "#500678",
    area: "Mt. Moon",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5323,
          y: 1194,
        },
        portal2: {
          x: 4248,
          y: 836,
        },
      },

      {
        portal1: {
          x: 4457,
          y: 837,
        },
        portal2: {
          x: 4782,
          y: 836,
        },
      },
      {
        portal1: {
          x: 4782,
          y: 865,
        },
        portal2: {
          x: 5387,
          y: 875,
        },
      },
      {
        portal1: {
          x: 5447,
          y: 1022,
        },
        portal2: {
          x: 4782,
          y: 1075,
        },
      },
      {
        portal1: {
          x: 4783,
          y: 1044,
        },
        portal2: {
          x: 4538,
          y: 982,
        },
      },

      // Exit
      {
        portal1: {
          x: 4536,
          y: 1071,
        },
        portal2: {
          x: 5896,
          y: 930,
        },
      },
    ],
  },
  {
    color: "#a30f83",
    area: "Cerulean Cave",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7307,
          y: 914,
        },
        portal2: {
          x: 7437,
          y: 734,
        },
      },

      // 1F
      {
        portal1: {
          x: 7538,
          y: 340,
        },
        portal2: {
          x: 6501,
          y: 332,
        },
      },
      {
        portal1: {
          x: 6880,
          y: 415,
        },
        portal2: {
          x: 5843,
          y: 405,
        },
      },
      {
        portal1: {
          x: 6768,
          y: 539,
        },
        portal2: {
          x: 5753,
          y: 530,
        },
      },
      {
        portal1: {
          x: 7200,
          y: 568,
        },
        portal2: {
          x: 6164,
          y: 578,
        },
      },
      {
        portal1: {
          x: 7376,
          y: 513,
        },
        portal2: {
          x: 6341,
          y: 503,
        },
      },
      {
        portal1: {
          x: 6750,
          y: 451,
        },
        portal2: {
          x: 4700,
          y: 415,
        },
      },
      {
        portal1: {
          x: 6800,
          y: 352,
        },
        portal2: {
          x: 5764,
          y: 342,
        },
      },

      // Exit Ladder
      {
        portal1: {
          x: 7538,
          y: 480,
        },
        portal2: {
          x: 5487,
          y: 453,
        },
      },
    ],
  },
  {
    color: "#09bd3f",
    area: "Viridian Forest",
    portals: [
      // Entrance
      {
        portal1: {
          x: 3197,
          y: 2549,
        },
        portal2: {
          x: 3979,
          y: 2772,
        },
      },

      // Exit
      {
        portal1: {
          x: 3659,
          y: 1751,
        },
        portal2: {
          x: 3103,
          y: 1711,
        },
      },
    ],
  },
  {
    color: "#6385b8",
    area: "Seafoam Islands",
    portals: [
      // Cinnabar Entrance
      {
        portal1: {
          x: 4678,
          y: 6797,
        },
        portal2: {
          x: 4363,
          y: 6397,
        },
      },
      // Cinnabar Staircase
      {
        portal1: {
          x: 4283,
          y: 6297,
        },
        portal2: {
          x: 4449,
          y: 6105,
        },
      },

      // B1
      {
        portal1: {
          x: 4226,
          y: 6130,
        },
        portal2: {
          x: 4235,
          y: 5735,
        },
      },
      {
        portal1: {
          x: 3986,
          y: 5960,
        },
        portal2: {
          x: 3980,
          y: 5562,
        },
      },
      {
        portal1: {
          x: 3922,
          y: 6081,
        },
        portal2: {
          x: 3931,
          y: 5684,
        },
      },
      {
        portal1: {
          x: 3826,
          y: 6107,
        },
        portal2: {
          x: 3834,
          y: 5699,
        },
      },

      // B2
      {
        portal1: {
          x: 4379,
          y: 5576,
        },
        portal2: {
          x: 4371,
          y: 5152,
        },
      },
      {
        portal1: {
          x: 4362,
          y: 5680,
        },
        portal2: {
          x: 4355,
          y: 5291,
        },
      },
      {
        portal1: {
          x: 4058,
          y: 5569,
        },
        portal2: {
          x: 4051,
          y: 5166,
        },
      },
      {
        portal1: {
          x: 3769,
          y: 5713,
        },
        portal2: {
          x: 3746,
          y: 5291,
        },
      },

      // B3
      {
        portal1: {
          x: 3761,
          y: 5047,
        },
        portal2: {
          x: 3746,
          y: 4609,
        },
      },
      {
        portal1: {
          x: 3842,
          y: 4782,
        },
        portal2: {
          x: 3858,
          y: 5242,
        },
      },
      {
        portal1: {
          x: 4114,
          y: 5144,
        },
        portal2: {
          x: 4098,
          y: 4709,
        },
      },
      {
        portal1: {
          x: 4193,
          y: 5044,
        },
        portal2: {
          x: 4179,
          y: 4596,
        },
      },
      {
        portal1: {
          x: 4274,
          y: 5277,
        },
        portal2: {
          x: 4258,
          y: 4831,
        },
      },
      {
        portal1: {
          x: 4386,
          y: 5255,
        },
        portal2: {
          x: 4371,
          y: 4819,
        },
      },

      // Violet Staircase
      {
        portal1: {
          x: 4132,
          y: 6297,
        },
        portal2: {
          x: 3727,
          y: 5946,
        },
      },
      // Violet Entrance
      {
        portal1: {
          x: 4455,
          y: 6701,
        },
        portal2: {
          x: 4071,
          y: 6397,
        },
      },
    ],
  },
  {
    color: "#8a169c",
    area: "Fuschia Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5770,
          y: 5855,
        },
        portal2: {
          x: 5507,
          y: 6099,
        },
      },
    ],
  },
  {
    color: "#545254",
    area: "Pewter Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 3404,
          y: 1095,
        },
        portal2: {
          x: 2876,
          y: 1283,
        },
      },
    ],
  },
  {
    color: "#9e3813",
    area: "Vermilion Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7412,
          y: 3991,
        },
        portal2: {
          x: 7211,
          y: 4073,
        },
      },
    ],
  },
  {
    color: "#117c91",
    area: "Cerulean Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7758,
          y: 1222,
        },
        portal2: {
          x: 8335,
          y: 1115,
        },
      },
    ],
  },
  {
    color: "#0e8a24",
    area: "Celadon Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5901,
          y: 3198,
        },
        portal2: {
          x: 5633,
          y: 3775,
        },
      },
    ],
  },
  {
    color: "#4c1278",
    area: "Saffron Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7941,
          y: 2456,
        },
        portal2: {
          x: 8052,
          y: 2360,
        },
      },
      {
        portal1: {
          x: 8097,
          y: 2287,
        },
        portal2: {
          x: 8257,
          y: 2323,
        },
      },
      {
        portal1: {
          x: 8162,
          y: 2285,
        },
        portal2: {
          x: 8257,
          y: 2063,
        },
      },
      {
        portal1: {
          x: 8258,
          y: 2101,
        },
        portal2: {
          x: 7843,
          y: 2286,
        },
      },
      {
        portal1: {
          x: 7938,
          y: 2324,
        },
        portal2: {
          x: 7938,
          y: 2213,
        },
      },
      {
        portal1: {
          x: 7842,
          y: 2212,
        },
        portal2: {
          x: 7938,
          y: 2102,
        },
      },
      {
        portal1: {
          x: 7842,
          y: 2102,
        },
        portal2: {
          x: 8098,
          y: 2225,
        },
      },
    ],
  },
  {
    color: "#3d0904",
    area: "Cinnabar Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4366,
          y: 6346,
        },
        portal2: {
          x: 4722,
          y: 6411,
        },
      },
    ],
  },
  {
    color: "#1b421a",
    area: "Viridian Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 3372,
          y: 3245,
        },
        portal2: {
          x: 3649,
          y: 3561,
        },
      },
    ],
  },
  {
    color: "#bbc1c9",
    area: "Mt. Silver",
    portals: [
      // Entrance
      {
        portal1: {
          x: 169,
          y: 3420,
        },
        portal2: {
          x: 717,
          y: 3260,
        },
      },

      // 1F
      {
        portal1: {
          x: 621,
          y: 3030,
        },
        portal2: {
          x: 1193,
          y: 2654,
        },
      },
      {
        portal1: {
          x: 316,
          y: 2544,
        },
        portal2: {
          x: 209,
          y: 2401,
        },
      },
      {
        portal1: {
          x: 905,
          y: 3017,
        },
        portal2: {
          x: 1433,
          y: 3159,
        },
      },
      {
        portal1: {
          x: 1367,
          y: 3077,
        },
        portal2: {
          x: 941,
          y: 2935,
        },
      },
      {
        portal1: {
          x: 975,
          y: 2705,
        },
        portal2: {
          x: 1305,
          y: 2846,
        },
      },
      {
        portal1: {
          x: 589,
          y: 2478,
        },
        portal2: {
          x: 744,
          y: 2282,
        },
      },

      // 2F
      {
        portal1: {
          x: 1043,
          y: 2017,
        },
        portal2: {
          x: 1709,
          y: 1799,
        },
      },
      {
        portal1: {
          x: 1707,
          y: 1948,
        },
        portal2: {
          x: 1041,
          y: 2164,
        },
      },
      {
        portal1: {
          x: 1044,
          y: 2314,
        },
        portal2: {
          x: 1705,
          y: 2094,
        },
      },
      {
        portal1: {
          x: 1606,
          y: 2196,
        },
        portal2: {
          x: 966,
          y: 2392,
        },
      },
      {
        portal1: {
          x: 742,
          y: 2392,
        },
        portal2: {
          x: 1384,
          y: 2198,
        },
      },
      {
        portal1: {
          x: 742,
          y: 1929,
        },
        portal2: {
          x: 1487,
          y: 1725,
        },
      },
      {
        portal1: {
          x: 1321,
          y: 1985,
        },
        portal2: {
          x: 838,
          y: 1841,
        },
      },

      // Exit
      {
        portal1: {
          x: 501,
          y: 1520,
        },
        portal2: {
          x: 782,
          y: 1371,
        },
      },
    ],
  },
];
